import React, {
  useEffect,
  useRef,
  useState,
} from "react";
import { FiSearch, FiFilter } from "react-icons/fi";
import { useSearchParams } from "react-router-dom";

import {
  getDroppedLeads,
  restoreDroppedLeads,
  assignDroppedLeads,
  bulkDeleteDroppedLeads,
  getUsers,
} from "../api";

import DropTable from "../components/DropTable";

const DROP_SCROLL_KEY = "aranyaka_drop_scroll";

export default function Drop() {
  const [searchParams, setSearchParams] =
    useSearchParams();

  const initialPage = Math.max(
    Number(searchParams.get("page")) || 1,
    1
  );

  const initialLimit = Math.max(
    Number(searchParams.get("limit")) || 100,
    1
  );

  const initialReason =
    searchParams.get("reason") || "All";

  const initialSearch =
    searchParams.get("search") || "";

  const [leads, setLeads] = useState([]);

  const [search, setSearch] =
    useState(initialSearch);

  const [searchText, setSearchText] =
    useState(initialSearch);

  const [selectedReason, setSelectedReason] =
    useState(initialReason);

  const [selectedLeads, setSelectedLeads] =
    useState([]);

  const [users, setUsers] = useState([]);

  const [showAssignModal, setShowAssignModal] =
    useState(false);

  const [selectedUser, setSelectedUser] =
    useState("");

  const [showBulkMenu, setShowBulkMenu] =
    useState(false);

  const [page, setPage] =
    useState(initialPage);

  const [limit, setLimit] =
    useState(initialLimit);

  const [totalPages, setTotalPages] =
    useState(1);

  const [totalLeads, setTotalLeads] =
    useState(0);

  const [loading, setLoading] =
    useState(true);

 const [showFilterPanel, setShowFilterPanel] = useState(false);


// ========================================
// QUICK FILTER
// ========================================
const [quickFilter, setQuickFilter] = useState("");
const [showQuickFilter, setShowQuickFilter] = useState(false);


const [filterDroppedBy, setFilterDroppedBy] = useState("");
const [filterAssignedTo, setFilterAssignedTo] = useState("");
const [filterSource, setFilterSource] = useState("");

const [filterName, setFilterName] = useState("");
const [filterContact, setFilterContact] = useState("");
const [droppedFrom, setDroppedFrom] = useState("");
const [droppedTo, setDroppedTo] = useState("");

  const dropScrollRef = useRef(null);
  const scrollRestoredRef = useRef(false);

 useEffect(() => {
  loadDroppedLeads();
}, [
  page,
  limit,
  search,
  selectedReason,
  quickFilter,
]);

  useEffect(() => {
    loadUsers();
  }, []);

  // Page, limit, search and reason ko URL me save karega
  useEffect(() => {
    setSearchParams(
      (currentParams) => {
        const nextParams =
          new URLSearchParams(currentParams);

        nextParams.set(
          "page",
          String(page)
        );

        nextParams.set(
          "limit",
          String(limit)
        );

        if (selectedReason !== "All") {
          nextParams.set(
            "reason",
            selectedReason
          );
        } else {
          nextParams.delete("reason");
        }

        if (search.trim()) {
          nextParams.set(
            "search",
            search.trim()
          );
        } else {
          nextParams.delete("search");
        }

        return nextParams;
      },
      {
        replace: true,
      }
    );
  }, [
    page,
    limit,
    selectedReason,
    search,
    setSearchParams,
  ]);

  // Drop detail se Back aane par scroll restore karega
  useEffect(() => {
    if (
      loading ||
      scrollRestoredRef.current
    ) {
      return;
    }

    const savedScrollTop =
      Number(
        sessionStorage.getItem(
          DROP_SCROLL_KEY
        )
      ) || 0;

    const timer = window.setTimeout(() => {
      if (dropScrollRef.current) {
        dropScrollRef.current.scrollTop =
          savedScrollTop;
      }

      scrollRestoredRef.current = true;
    }, 100);

    return () =>
      window.clearTimeout(timer);
  }, [loading]);

  const resetDropScroll = () => {
    sessionStorage.setItem(
      DROP_SCROLL_KEY,
      "0"
    );

    if (dropScrollRef.current) {
      dropScrollRef.current.scrollTop = 0;
    }
  };

  async function loadDroppedLeads() {
    try {
      setLoading(true);

      const params = {};

      if (search.trim()) {
        params.search = search.trim();
      }

      if (selectedReason !== "All") {
        params.reason = selectedReason;
      }

      if (filterName) {
  params.name = filterName;
}

if (filterContact) {
  params.contact = filterContact;
}

if (filterDroppedBy) {
  params.dropped_by = filterDroppedBy;
}

if (filterAssignedTo) {
  params.assigned_to = filterAssignedTo;
}

if (filterSource) {
  params.source = filterSource;
}

if (droppedFrom) {
  params.dropped_from = droppedFrom;
}


if (droppedTo) {
  params.dropped_to = droppedTo;
}

if (quickFilter === "dropped_today") {
  params.dropped_today = "true";
}

if (quickFilter === "duplicate") {
  params.duplicate = "true";
}

if (quickFilter === "non_duplicate") {
  params.duplicate = "false";
}

const response =
  await getDroppedLeads(
    page,
    limit,
    params
  );



      setLeads(
        Array.isArray(response.data?.data)
          ? response.data.data
          : []
      );

      setTotalLeads(
        Number(response.data?.total || 0)
      );

      setTotalPages(
        Number(
          response.data?.totalPages || 1
        )
      );
        } catch (error) {
      console.error(
        "LOAD DROPPED LEADS ERROR:",
        error
      );

      console.error(
        "STATUS:",
        error.response?.status
      );

      console.error(
        "SERVER RESPONSE:",
        error.response?.data
      );

      setLeads([]);
    } finally {
      setLoading(false);
    }
  }

  async function loadUsers() {
    try {
      const response = await getUsers();

      const usersData =
        Array.isArray(response.data)
          ? response.data
          : [];

      setUsers(
        usersData.filter(
          (user) =>
            user.role ===
              "sales_manager" &&
            user.is_active !== false
        )
      );
    } catch (error) {
      console.error(
        "LOAD USERS ERROR:",
        error
      );

      setUsers([]);
    }
  }

  const reasons = [
    "All",
    ...new Set(
      leads
        .map(
          (lead) => lead.drop_reason
        )
        .filter(Boolean)
    ),
  ];

  const toggleLead = (leadId) => {
    setSelectedLeads(
      (previousSelectedLeads) =>
        previousSelectedLeads.includes(
          leadId
        )
          ? previousSelectedLeads.filter(
              (selectedId) =>
                selectedId !== leadId
            )
          : [
              ...previousSelectedLeads,
              leadId,
            ]
    );
  };

  const handleSelectAll = () => {
    if (
      leads.length > 0 &&
      selectedLeads.length ===
        leads.length
    ) {
      setSelectedLeads([]);
      return;
    }

    setSelectedLeads(
      leads.map((lead) => lead.id)
    );
  };

  async function restoreSelected() {
    if (!selectedLeads.length) {
      return;
    }

    try {
      await restoreDroppedLeads(
        selectedLeads
      );

      setSelectedLeads([]);
      setShowBulkMenu(false);

      await loadDroppedLeads();
    } catch (error) {
      console.error(
        "RESTORE DROPPED LEADS ERROR:",
        error
      );

      alert(
        error.response?.data?.error ||
          "Could not restore selected leads."
      );
    }
  }

  async function assignSelected() {
    if (!selectedUser) {
      alert(
        "Please select Sales Manager"
      );
      return;
    }

    if (!selectedLeads.length) {
      alert(
        "Please select at least one dropped lead."
      );
      return;
    }

    try {
      await assignDroppedLeads(
        selectedLeads,
        selectedUser
      );

      setShowAssignModal(false);
      setSelectedUser("");
      setSelectedLeads([]);
      setShowBulkMenu(false);

      await loadDroppedLeads();
    } catch (error) {
      console.error(
        "ASSIGN DROPPED LEADS ERROR:",
        error
      );

      alert(
        error.response?.data?.error ||
          "Could not assign selected leads."
      );
    }
  }

  async function handleDeleteSelected() {
    if (selectedLeads.length === 0) {
      alert(
        "Please select at least one dropped lead."
      );
      return;
    }

    const confirmDelete =
      window.confirm(
        `Delete ${selectedLeads.length} selected dropped lead(s)?`
      );

    if (!confirmDelete) {
      return;
    }

    try {
      const response =
        await bulkDeleteDroppedLeads(
          selectedLeads
        );

      alert(
        response.data?.message ||
          "Dropped leads deleted successfully."
      );

      setSelectedLeads([]);
      setShowBulkMenu(false);

      await loadDroppedLeads();
    } catch (error) {
      console.error(
        "DELETE DROPPED LEADS ERROR:",
        error
      );

      alert(
        error.response?.data?.error ||
          error.response?.data?.message ||
          "Unable to delete dropped leads."
      );
    }
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      {/* Header */}
      <div className="page-header">
        <div>
          <div className="page-title">
            All Drop
          </div>

          <div className="page-subtitle">
            {totalLeads} Leads
          </div>
        </div>

        <div
  style={{
    display: "flex",
    gap: 8,
    alignItems: "center",
  }}
>
  <input
    className="form-input"
    style={{
      width: 220,
    }}
    placeholder="Search name, phone..."
    value={searchText}
    onChange={(event) =>
      setSearchText(
        event.target.value
      )
    }
    onKeyDown={(event) => {
      if (
        event.key !== "Enter"
      ) {
        return;
      }

      resetDropScroll();
      setSearch(
        searchText.trim()
      );
      setPage(1);
    }}
  />

  <div
    style={{
      position: "relative",
    }}
  >
    <button
      type="button"
      onClick={() =>
        setShowQuickFilter(
          (previous) => !previous
        )
      }
      title="Quick Filters"
      style={{
        width: 38,
        height: 38,
        border: quickFilter
          ? "1px solid #1D9E75"
          : "1px solid #D9D9D9",
        borderRadius: 10,
        background: quickFilter
          ? "#ECFDF5"
          : "#fff",
        color: quickFilter
          ? "#1D9E75"
          : "#555",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <FiFilter size={18} />
    </button>

    {showQuickFilter && (
      <div
        style={{
          position: "absolute",
          top: "calc(100% + 8px)",
          right: 0,
          width: 190,
          background: "#fff",
          border: "1px solid #E5E7EB",
          borderRadius: 8,
          boxShadow:
            "0 8px 24px rgba(0,0,0,.14)",
          zIndex: 9999,
          overflow: "hidden",
        }}
      >
        {[
          {
            value: "dropped_today",
            label: "Dropped Today",
          },
          {
            value: "duplicate",
            label: "Duplicate",
          },
          {
            value: "non_duplicate",
            label: "Non Duplicate",
          },
        ].map((item) => (
          <div
            key={item.value}
            onClick={() => {
              resetDropScroll();
              setQuickFilter(item.value);
              setPage(1);
              setShowQuickFilter(false);
            }}
            style={{
              padding: "11px 14px",
              cursor: "pointer",
              fontSize: 13,
              background:
                quickFilter === item.value
                  ? "#ECFDF5"
                  : "#fff",
              color:
                quickFilter === item.value
                  ? "#1D9E75"
                  : "#222",
              fontWeight:
                quickFilter === item.value
                  ? 600
                  : 400,
              borderBottom:
                "1px solid #F3F4F6",
            }}
          >
            {item.label}
          </div>
        ))}

        <div
          onClick={() => {
            resetDropScroll();
            setQuickFilter("");
            setPage(1);
            setShowQuickFilter(false);
          }}
          style={{
            padding: "11px 14px",
            cursor: "pointer",
            fontSize: 13,
            color: "#DC2626",
          }}
        >
          Clear Filter
        </div>
      </div>
    )}
  </div>
</div>
      </div>

      {/* Drop reason filters */}
      <div
        style={{
          display: "flex",
          justifyContent:
            "space-between",
          alignItems: "center",
          padding: "10px 20px",
          background: "#fff",
          borderBottom:
            "1px solid #eee",
          gap: 12,
          flexShrink: 0,
        }}
      >
        <div
          style={{
            display: "flex",
            gap: 8,
            flexWrap: "wrap",
          }}
        >
          {reasons.map((reason) => (
            <button
              key={reason}
              type="button"
              onClick={() => {
                resetDropScroll();

                setSelectedReason(
                  reason
                );

                setPage(1);
              }}
              style={{
                padding: "5px 14px",
                borderRadius: 20,
                border:
                  "1px solid #ddd",
                cursor: "pointer",
                background:
                  selectedReason ===
                  reason
                    ? "#16A34A"
                    : "#fff",
                color:
                  selectedReason ===
                  reason
                    ? "#fff"
                    : "#555",
              }}
            >
              {reason}
            </button>
          ))}
        </div>

        <div
  onClick={() => setShowFilterPanel(true)}
  style={{
    width: 38,
    height: 29,
    borderRadius: "50%",
    border: "1px solid #D9D9D9",
    background: "#fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    flexShrink: 0,
  }}
>
  <FiSearch size={18} color="#666" />
</div>      </div>

      {/* Scrollable table area */}
      <div
        ref={dropScrollRef}
        onScroll={(event) => {
          sessionStorage.setItem(
            DROP_SCROLL_KEY,
            String(
              event.currentTarget
                .scrollTop
            )
          );
        }}
        style={{
          flex: 1,
          overflow: "auto",
          padding: "0 20px",
        }}
      >
        {/* Single pagination bar */}
        <div
          style={{
            display: "flex",
            justifyContent:
              "space-between",
            alignItems: "center",
            padding: "10px 0",
            background: "#fff",
            borderBottom:
              "1px solid #eee",
            marginBottom: 8,
            position: "sticky",
            top: 0,
            zIndex: 20,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              fontSize: 13,
            }}
          >
            <label htmlFor="drop-page-limit">
              Show:
            </label>

            <select
              id="drop-page-limit"
              value={limit}
              onChange={(event) => {
                resetDropScroll();

                setLimit(
                  Number(
                    event.target.value
                  )
                );

                setPage(1);
              }}
              style={{
                height: 30,
                padding: "0 8px",
                border:
                  "1px solid #ccc",
                borderRadius: 4,
              }}
            >
              <option value={30}>
                30
              </option>

              <option value={50}>
                50
              </option>

              <option value={100}>
                100
              </option>

              <option value={200}>
                200
              </option>

              <option value={500}>
                500
              </option>

              <option value={1000}>
                1000
              </option>
            </select>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              fontSize: 13,
            }}
          >
            <button
              type="button"
              disabled={page <= 1}
              onClick={() => {
                resetDropScroll();

                setPage(
                  (currentPage) =>
                    currentPage - 1
                );
              }}
              style={{
                padding: "5px 10px",
                cursor:
                  page <= 1
                    ? "not-allowed"
                    : "pointer",
              }}
            >
              Previous
            </button>

            <span>
              Page {page} of{" "}
              {totalPages}
            </span>

            <button
              type="button"
              disabled={
                page >= totalPages
              }
              onClick={() => {
                resetDropScroll();

                setPage(
                  (currentPage) =>
                    currentPage + 1
                );
              }}
              style={{
                padding: "5px 10px",
                cursor:
                  page >= totalPages
                    ? "not-allowed"
                    : "pointer",
              }}
            >
              Next
            </button>
          </div>
        </div>

        {loading ? (
          <div className="loading-screen">
            <div className="spinner" />
          </div>
        ) : (
          <DropTable
            leads={leads}
            page={page}
            limit={limit}
            selectedLeads={
              selectedLeads
            }
            toggleLead={toggleLead}
            handleSelectAll={
              handleSelectAll
            }
            showBulkMenu={
              showBulkMenu
            }
            setShowBulkMenu={
              setShowBulkMenu
            }
            restoreSelected={
              restoreSelected
            }
            setShowAssignModal={
              setShowAssignModal
            }
            handleDeleteSelected={
              handleDeleteSelected
            }
          />
        )}
      </div>

      {/* Assign modal */}
      {showAssignModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background:
              "rgba(0,0,0,0.35)",
            display: "flex",
            justifyContent:
              "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              width: 500,
              background: "#fff",
              borderRadius: 12,
              padding: 32,
              boxShadow:
                "0 12px 30px rgba(0,0,0,.18)",
            }}
          >
            <h2
              style={{
                margin: 0,
                marginBottom: 24,
                fontSize: 18,
                fontWeight: 700,
                color: "#111827",
              }}
            >
              Assign Leads
            </h2>

            <select
              className="form-input"
              value={selectedUser}
              onChange={(event) =>
                setSelectedUser(
                  event.target.value
                )
              }
              style={{
                width: "100%",
                height: 50,
                fontSize: 16,
                borderRadius: 8,
                marginBottom: 28,
              }}
            >
              <option value="">
                Select Sales Manager
              </option>

              {users.map((user) => (
                <option
                  key={user.id}
                  value={user.id}
                >
                  {user.name}
                </option>
              ))}
            </select>

            <div
              style={{
                display: "flex",
                justifyContent:
                  "flex-end",
                gap: 12,
              }}
            >
              <button
                type="button"
                onClick={() => {
                  setShowAssignModal(
                    false
                  );

                  setSelectedUser("");
                }}
                style={{
                  height: 44,
                  padding: "0 22px",
                  border:
                    "1px solid #D1D5DB",
                  background: "#fff",
                  borderRadius: 8,
                  cursor: "pointer",
                  fontWeight: 500,
                  fontSize: 15,
                }}
              >
                Cancel
              </button>

              <button
                type="button"
                onClick={assignSelected}
                style={{
                  height: 44,
                  padding: "0 24px",
                  background:
                    "#16A34A",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  cursor: "pointer",
                  fontWeight: 600,
                  fontSize: 15,
                }}
              >
                Assign
              </button>
            </div>
          </div>
        </div>
      )}

      
  <div
    onClick={() => setShowFilterPanel(false)}
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,.25)",
      zIndex: 9998,
      opacity: showFilterPanel ? 1 : 0,
      visibility: showFilterPanel ? "visible" : "hidden",
      transition: "all .30s ease",
    }}
  />

  <div
    style={{
      position: "fixed",
      top: 0,
      right: 0,
      width: 370,
      height: "100vh",
      background: "#fff",
      zIndex: 9999,
      boxShadow: "-5px 0 25px rgba(0,0,0,.15)",
      transform: showFilterPanel
        ? "translateX(0)"
        : "translateX(100%)",
      transition: "transform 350ms cubic-bezier(.22,1,.36,1)",
      padding: 25,
      overflowY: "auto",
    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 25,
      }}
    >
      <h3 style={{ margin: 0, fontSize: 18 }}>
        Filter Dropped Leads
      </h3>

      <button
        onClick={() => setShowFilterPanel(false)}
        style={{
          border: "none",
          background: "transparent",
          fontSize: 24,
          cursor: "pointer",
        }}
      >
        ×
      </button>
    </div>

    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 18,
      }}
    >
      <div>
        <label style={{ display: "block", marginBottom: 6 }}>
          Lead Date From
        </label>
        <input
          type="date"
          value={droppedFrom}
          onChange={(e) => setDroppedFrom(e.target.value)}
          style={{
            width: "100%",
            height: 42,
            border: "1px solid #D9D9D9",
            borderRadius: 4,
            padding: "0 10px",
          }}
        />
      </div>

      <div>
        <label style={{ display: "block", marginBottom: 6 }}>
          Lead Date To
        </label>
        <input
          type="date"
          value={droppedTo}
          onChange={(e) => setDroppedTo(e.target.value)}
          style={{
            width: "100%",
            height: 42,
            border: "1px solid #D9D9D9",
            borderRadius: 4,
            padding: "0 10px",
          }}
        />
      </div>

      <div>
        <label style={{ display: "block", marginBottom: 6 }}>
          Dropped By
        </label>

        <select
          value={filterDroppedBy}
          onChange={(e) => setFilterDroppedBy(e.target.value)}
          style={{
            width: "100%",
            height: 42,
            border: "1px solid #D9D9D9",
            borderRadius: 4,
            padding: "0 10px",
          }}
        >
          <option value="">Select</option>

          {users.map((user) => (
            <option key={user.id} value={user.id}>
              {user.name}
            </option>
          ))}
        </select>
      </div>
          
          <div>
  <label style={{ display: "block", marginBottom: 6 }}>
    Assigned To
  </label>

  <select
    value={filterAssignedTo}
    onChange={(e) => setFilterAssignedTo(e.target.value)}
    style={{
      width: "100%",
      height: 42,
      border: "1px solid #D9D9D9",
      borderRadius: 4,
      padding: "0 10px",
    }}
  >
    <option value="">Select</option>

    {users.map((user) => (
      <option key={user.id} value={user.id}>
        {user.name}
      </option>
    ))}
  </select>
</div>

      <div>
        <label style={{ display: "block", marginBottom: 6 }}>
          Name
        </label>

        <input
          type="text"
          value={filterName}
          onChange={(e) => setFilterName(e.target.value)}
          style={{
            width: "100%",
            height: 42,
            border: "1px solid #D9D9D9",
            borderRadius: 4,
            padding: "0 10px",
          }}
        />
      </div>

      <div>
        <label style={{ display: "block", marginBottom: 6 }}>
          Contact
        </label>

        <input
          type="text"
          value={filterContact}
          onChange={(e) => setFilterContact(e.target.value)}
          style={{
            width: "100%",
            height: 42,
            border: "1px solid #D9D9D9",
            borderRadius: 4,
            padding: "0 10px",
          }}
        />
      </div>

      <div>
        <label style={{ display: "block", marginBottom: 6 }}>
          Source
        </label>

        <input
          type="text"
          value={filterSource}
          onChange={(e) => setFilterSource(e.target.value)}
          style={{
            width: "100%",
            height: 42,
            border: "1px solid #D9D9D9",
            borderRadius: 4,
            padding: "0 10px",
          }}
        />
      </div>

      <button
        onClick={() => {
  resetDropScroll();

  if (page === 1) {
    loadDroppedLeads();
  } else {
    setPage(1);
  }

  setShowFilterPanel(false);
}}
        style={{
          background: "#7CB518",
          color: "#fff",
          border: "none",
          borderRadius: 25,
          padding: "12px 38px",
          fontSize: 15,
          fontWeight: 600,
          cursor: "pointer",
          marginTop: 10,
        }}
      >
        Apply
      </button>
    </div>
  </div>

    </div>
  );
}